<template>
  <v-card
    elevation="5"
    id="drugs-info"
    class="white drugs-info"
    :max-width="_getMaxWidth()"
  >
    <div
      v-if="!isDrugsManagement"
      ref="drugsInfoHeader"
      class="drugs-info-header"
    >
      <!-- Header -->
      <vetalfa-small-header
        :isDrugsManagement="isDrugsManagement"
        :title="category ? category.portugueseName : null"
        hasShareOption
      ></vetalfa-small-header>

      <!-- Tabs Title -->
      <v-tabs
        v-show="!isDrugsManagement"
        v-model="tabModel"
        v-if="drug"
        background-color="transparent"
        color="#004662 !important"
        centered
        height="50px"
        class="mt-2"
        icons-and-text
        grow
      >
        <v-tab
          class="text-capitalize"
          v-bind:style="tabStyle"
          v-for="(tab, index) in tabs"
          :key="tab.name"
          @click="
            $vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: 'easeInOutCubic',
            })
          "
        >
          {{ tab.name }}
          <v-icon
            v-bind:style="index == tabModel ? 'color:#004662' : 'color:#393a3a'"
            >{{ tab.icon }}</v-icon
          >
        </v-tab>
      </v-tabs>

      <!-- Summary -->
      <vetalfa-drugs-header
        v-if="drug"
        :name="drug.name"
        :description="drug.description"
        :isDrugsManagement="isDrugsManagement"
        displayInteractions
      ></vetalfa-drugs-header>
    </div>

    <!-- Tabs Content -->
    <div
      v-if="drug && !drug.vaccines_suplements_serums"
      id="drugsInfoContent"
      ref="drugsInfoContent"
      class="drugs-info-content"
    >
      <v-tabs-items v-model="tabModel" class="drugs-info-tab-item">
        <v-tab-item v-show="tabModel == 0 && drug.info">
          <vetalfa-general-tab
            :sections="drug.info"
            :references="references"
          ></vetalfa-general-tab>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 1 && drug.doses">
          <vetalfa-doses-tab
            :isDrugsManagement="isDrugsManagement"
            :doses="drug.doses"
          ></vetalfa-doses-tab>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 2 && drug.attention">
          <vetalfa-general-tab :sections="drug.attention"></vetalfa-general-tab>
        </v-tab-item>
        <v-tab-item v-show="tabModel == 3">
          <vetalfa-products-tab
            :isDrugsManagement="isDrugsManagement"
            :veterinary_products="drug.veterinary_products"
            :human_products="drug.human_products"
          ></vetalfa-products-tab>
        </v-tab-item>
      </v-tabs-items>
      <div class="navigation-blank-space"></div>
    </div>
    <div
      v-if="drug && drug.vaccines_suplements_serums"
      id="drugsInfoContent"
      ref="drugsInfoContent"
      class="drugs-info-content"
    >
      <vetalfa-products-tab
        :isDrugsManagement="isDrugsManagement"
        :veterinary_products="drug.veterinary_products"
        :human_products="drug.human_products"
      ></vetalfa-products-tab>
      <div class="navigation-blank-space"></div>
    </div>

    <!-- Navigation Button -->
    <v-fab-transition v-if="!isDrugsManagement && !showNavigation">
      <v-row
        @click="openNavigation()"
        align="center"
        justify="center"
        class="ma-0 pa-0 drugs-info-fab"
      >
        <v-img :src="navigation" max-height="30px" max-width="30px"></v-img>
      </v-row>
    </v-fab-transition>
    <!-- Navigation Dialog -->
    <v-dialog
      v-if="!isDrugsManagement && showNavigation"
      :value="showNavigation"
      v-model="showNavigation"
      max-width="300"
    >
      <v-card
        v-if="drug && showNavigation"
        class="white"
        max-width="300"
        height="400"
        style="overflow-y: hidden !important"
      >
        <div ref="navigationCard">
          <div v-bind:style="navigationHeaderStyle">
            <vetalfa-small-header
              :backMethod="closeNavigation"
              :title="drug.name"
              isNavigationDialog
              closable
            ></vetalfa-small-header>
            <v-tabs
              v-model="navigationTabModel"
              v-if="drug"
              background-color="transparent"
              color="#004662 !important"
              height="50px"
              class="mt-2"
              grow
              icons-and-text
            >
              <div v-for="(tab, index) in tabs" :key="tab.name">
                <v-tab
                  v-if="index != 1"
                  class="text-capitalize"
                  v-bind:style="navigationTabStyle"
                >
                  {{ tab.name }}
                  <v-icon
                    v-bind:style="
                      index == (navigationTabModel ? navigationTabModel + 1 : 0)
                        ? 'color:#004662'
                        : 'color:#393a3a'
                    "
                    >{{ tab.icon }}</v-icon
                  >
                </v-tab>
              </div>
            </v-tabs>
          </div>
          <v-container fluid class="overflow-y-auto navigation-container">
            <v-row class="ma-n2 py-1" align="center" justify="center">
              <v-tabs-items
                v-model="navigationTabModel"
                class="drugs-info-tab-item white"
              >
                <v-tab-item
                  v-for="(tab, index) in tabs"
                  :key="tab.name + index"
                >
                  <v-row
                    v-if="navigationTabModel == 0 || navigationTabModel == 1"
                    align="start"
                    align-content="start"
                    justify="start"
                    class="pa-0 ma-0 drugs-info-navigation-body"
                  >
                    <v-col
                      @click="navigateToSection(section.description)"
                      v-for="section in navigationTabModel
                        ? drug.attention
                        : drug.info"
                      :key="'nav' + section.description"
                      cols="12"
                      class="px-2 pt-3 pb-0 ma-0 drugs-info-navigation-item"
                    >
                      <v-card elevation="1" height="40px">
                        <v-row
                          class="ma-0 pa-0"
                          align="center"
                          justify="center"
                          style="height: 40px"
                        >
                          <p class="pa-0 ma-0 py-1 text-center">
                            {{ section.description }}
                          </p>
                        </v-row>
                      </v-card>
                    </v-col>
                    <v-col
                      @click="navigateToSection(references_label)"
                      v-if="navigationTabModel == 0"
                      cols="12"
                      class="px-2 pt-3 pb-0 ma-0 drugs-info-navigation-item"
                    >
                      <v-card elevation="1" height="40px">
                        <v-row
                          class="ma-0 pa-0"
                          align="center"
                          justify="center"
                          style="height: 40px"
                        >
                          <p class="pa-0 ma-0 py-1 text-center">
                            {{ references_label }}
                          </p>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="navigationTabModel == 2"
                    class="pa-0 ma-0 drugs-info-navigation-body"
                    align="start"
                    align-content="start"
                    justify="start"
                  >
                    <v-col
                      v-if="drug.veterinary_products.length"
                      cols="12"
                      class="px-2 pt-3 pb-0 ma-0 drugs-info-navigation-item"
                    >
                      <v-card
                        elevation="1"
                        :height="!showVetProduct ? '40px' : ''"
                      >
                        <v-row
                          class="ma-0 pa-0"
                          align="center"
                          justify="center"
                          style="height: 40px"
                          @click="showVetProduct = !showVetProduct"
                        >
                          <p class="pa-0 ma-0 py-1 text-center">
                            {{ veterinary_products_label }}
                          </p>
                          <v-icon
                            size="14"
                            style="position: absolute; right: 10px; top: 13px"
                            >{{
                              !showVetProduct
                                ? icons.mdiChevronDown
                                : icons.mdiChevronUp
                            }}</v-icon
                          >
                        </v-row>
                        <div v-show="showVetProduct">
                          <p
                            v-for="productsKey in veterinaryProductsMap"
                            :key="productsKey[0].presentation"
                            @click="
                              navigateToSection(
                                'vet' +
                                  _createIdentifier(productsKey[0].presentation)
                              )
                            "
                            class="
                              pa-0
                              ma-0
                              pt-3
                              text-center
                              drugs-info-navigation-item
                            "
                            style="height: 40px; vertical-align: middle"
                          >
                            {{ productsKey[0].presentation }}
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                    <v-col
                      v-if="drug.human_products.length"
                      cols="12"
                      class="px-2 pt-3 pb-0 ma-0"
                    >
                      <v-card
                        elevation="1"
                        :height="!showHumProduct ? '40px' : ''"
                      >
                        <v-row
                          class="ma-0 pa-0"
                          align="center"
                          justify="center"
                          style="height: 40px"
                          @click="showHumProduct = !showHumProduct"
                        >
                          <p
                            class="
                              pa-0
                              ma-0
                              py-1
                              text-center
                              drugs-info-navigation-item
                            "
                          >
                            {{ human_products_label }}
                          </p>
                          <v-icon
                            size="14"
                            style="position: absolute; right: 10px; top: 13px"
                            >{{
                              !showHumProduct
                                ? icons.mdiChevronDown
                                : icons.mdiChevronUp
                            }}</v-icon
                          >
                        </v-row>
                        <div v-show="showHumProduct">
                          <p
                            v-for="(presentationKey, index) in humanProductsMap"
                            :key="index + presentationKey.presentation"
                            @click="
                              navigateToSection(
                                'hum' +
                                  _createIdentifier(
                                    presentationKey.presentation
                                  )
                              )
                            "
                            class="
                              pa-0
                              ma-0
                              pt-3
                              text-center
                              drugs-info-navigation-item
                            "
                            style="height: 40px; vertical-align: middle"
                          >
                            {{ presentationKey.presentation }}
                          </p>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs-items>
            </v-row>
          </v-container>
        </div>
        <div align="end" class="ma-0 pa-0 pr-4 mt-1">
          <p class="text-right ma-0 pa-0 drugs-info-navigation-footer">
            {{ select_navigation_label }}
          </p>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style>
.drugs-info-fab {
  border-radius: 50% !important;
  background-color: #004662;
  position: fixed;
  bottom: 16px;
  right: 16px;
  cursor: pointer;
  height: 56px;
  width: 56px;
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}
.drugs-info-navigation-expand-icon {
  position: absolute;
  right: 10px;
  top: 20%;
}
.drugs-info-navigation-footer {
  opacity: 0.39;
  color: #393a3a;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
}
.drugs-info-navigation-item {
  cursor: pointer !important;
}
.drugs-info-navigation-body {
  font-size: 14px;
  background-color: white;
}
.drugs-info-header {
  color: transparent;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
  background-color: white;
  max-width: 768px;
}
.drugs-info-content {
  height: 100%;
}
.drugs-info-tab-item {
  height: 100%;
  width: 100% !important;
}
/* .v-slide-group__prev {
  display: none !important;
} */
.v-tab {
  min-width: 0 !important;
  box-shadow: none !important;
  font-size: 12px !important;
}
.v-tab:not(.v-tab--active) {
  color: #393a3a !important;
}
.drugs-info {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  height: 100%;
  width: 100%;
  border-radius: 0px;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  mdiArrowLeft,
  mdiDotsVertical,
  mdiMagnify,
  mdiClose,
  mdiShare,
  mdiChevronDown,
  mdiChevronUp,
} from "@mdi/js";
import images from "@/constants/images.js";
import labels from "@/constants/labels.js";
import enums from "@/constants/enums.js";
import parameters from "@/constants/parameters.js";
import { analytics } from "@/plugins/firebase.js";
export default {
  name: "DrugsInfo",
  props: {
    isDrugsManagement: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (!this.drug || this.drug.id != id) {
          this.setupDrug();
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    ...mapActions("drugs", ["openCategoryItem"]),
    ...mapMutations("drugs", ["setDrugTab"]),
    ...mapMutations("general", [
      "setLoadingOff",
      "setLoadingOn",
      "setGoToSection",
    ]),
    setupDrug() {
      if (!this.isDrugsManagement) {
        this.openCategoryItem({
          category: this.$route.params.category,
          id: this.$route.params.id,
          redirect: false,
        }).then(() => {
          this.setupScreenSizes();
        });
      }
    },
    navigateToSection(section_description) {
      this.setupScreenSizes();
      let promise = new Promise((resolve) => {
        this.showNavigation = false;
        this.tabModel = this.navigationTabModel
          ? this.navigationTabModel + 1
          : this.navigationTabModel;
        this.navigationTabModel = 0;
        resolve();
      }, this);
      promise.then(() => {
        setTimeout(
          function () {
            this.$vuetify.goTo(
              "#" + this._createIdentifier(section_description),
              {
                duration: 1000,
                offset: this.headerHeight,
                easing: "easeInOutCubic",
              }
            );
          }.bind(this),
          100
        );
      });
    },
    openNavigation() {
      this.analytics.logEvent("open_navigation");
      this.showNavigation = true;
      setTimeout(
        function () {
          this.navigationTabWidth = this.$refs.navigationCard.clientWidth;
        }.bind(this),
        200
      );
    },
    closeNavigation() {
      this.showNavigation = false;
    },
    setupScreenSizes() {
      setTimeout(
        function () {
          if (this.$refs.drugsInfoHeader && this.$refs.drugsInfoContent) {
            this.headerHeight = this.isDrugsManagement
              ? 300
              : this.$refs.drugsInfoHeader.offsetHeight + 1;
            this.$refs.drugsInfoContent.style.paddingTop =
              this.headerHeight + "px";
            this.$vuetify.goTo(0, {
              duration: 0,
              offset: 0,
              easing: "easeInOutCubic",
            });
            return;
          }
          this.setupScreenSizes();
        }.bind(this),
        100
      );
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "veterinaryProductsMap",
      "humanProductsMap",
      "drug",
      "drugTab",
      "category",
    ]),
    tabs() {
      let arr = [];
      if (this.drug && !this.drug.vaccines_suplements_serums) {
        enums.DRUGS_TABS.forEach((el, index) => {
          if (
            index != parameters.DRUGS_PRODUCT_TAB ||
            !!this.isDrugsManagement ||
            this.drug.human_products.length > 0 ||
            this.drug.veterinary_products.length > 0
          ) {
            arr.push(el);
          }
        });
      } else if (this.drug && !!this.drug.vaccines_suplements_serums) {
        arr.push(enums.DRUGS_TABS[parameters.DRUGS_PRODUCT_TAB]);
      }
      return arr;
    },
    tabStyle() {
      let width =
        (this.screenSize > this._getMaxWidth()
          ? this._getMaxWidth()
          : this.screenSize - 4) / 4;
      return "width:" + width + "px !important;";
    },
    tabModel: {
      get() {
        return this.drugTab;
      },
      set(tabModel) {
        this.setDrugTab(tabModel);
      },
    },
    navigationTabStyle() {
      let width = this.navigationTabWidth / (this.tabs.length - 1);
      return "width:" + width + "px !important;";
    },
    navigationHeaderStyle() {
      let width = this.navigationTabWidth;
      return (
        "width:" +
        width +
        "px !important;background-color:white;position: fixed !important;z-index: 5;max-width: 300px;"
      );
    },
    references() {
      var arr = [];
      this.drug.references.forEach((reference) => {
        arr.push(reference);
      });
      this.drug.doses.forEach((dose) => {
        if (dose.references) {
          dose.references.forEach((reference) => {
            arr = this._removeFromArrayWithName(arr, reference.name);
            arr.push(reference);
          });
        }
      });
      return arr;
    },
  },
  data() {
    return {
      screenSize: 768,
      icons: {
        mdiArrowLeft,
        mdiDotsVertical,
        mdiClose,
        mdiMagnify,
        mdiShare,
        mdiChevronDown,
        mdiChevronUp,
      },
      navigation: images.NAVIGATION,
      headerHeight: 0,
      showNavigation: false,
      navigationTabModel: 0,
      navigationTabWidth: 300,
      references_label: labels.REFERENCES,
      select_navigation_label: labels.SELECT_NAVIGATION,
      human_products_label: labels.HUMAN_PRODUCTS,
      veterinary_products_label: labels.VETERINARY_PRODUCTS,
      showHumProduct: false,
      showVetProduct: false,
      analytics,
    };
  },
  mounted() {
    this.screenSize =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth ||
      document.getElementById("drugs-info").clientWidth ||
      screenSize;
    this.setupDrug();
  },
};
</script>